import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { APPEARANCES, LAYOUTS } from './constants';
import getAppearanceConfig from './helpers/get-appearance-config';
import Icon from '../icon';
import Box from '../box';
import Stack from '../stack';
import Heading from '../heading';
import Paragraph from '../paragraph';
import ActionButton from '../action-button';
import IconButton from '../icon-button';
import { iconsList } from '../icon/glyphs';

const MOBILE_BREAKPOINT = 568;

// @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: s... Remove this comment to see the full error message
function CtaBanner({
  iconGlyph = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: string; onClick?: ((...args: any[]) => any) | undefined; } | undefined'.
  ctaButton = null,
  appearance = APPEARANCES.defaultCta,
  layout = LAYOUTS.default,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
  onClose = null,
  title,
  subtitle = null,
  roundedCorners = true,
  centered = false,
  animate = true,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
  onAnimationEnd = null,
}) {
  const [computedLayout, setComputedLayout] = useState(layout);
  const rootElementRef = useRef(null);

  useEffect(() => {
    const { current: animatedElement } = rootElementRef;

    if (animate && onAnimationEnd) {
      // @ts-ignore TS(2531): Object is possibly 'null'.
      animatedElement.addEventListener('animationend', onAnimationEnd, false);
    }

    return () => {
      if (animate && onAnimationEnd) {
        // @ts-ignore TS(2531): Object is possibly 'null'.
        animatedElement.removeEventListener('animationend', onAnimationEnd, false);
      }
    };
  }, [animate, onAnimationEnd]);

  useEffect(() => {
    function computeLayout() {
      const isMobileViewportMatched = window.matchMedia(
        `(max-width: ${MOBILE_BREAKPOINT}px)`
      ).matches;

      if (isMobileViewportMatched) {
        if (computedLayout !== LAYOUTS.mobile) {
          setComputedLayout(LAYOUTS.mobile);
        }

        return;
      }

      if (layout !== computedLayout) {
        setComputedLayout(layout);
      }
    }

    computeLayout();

    if (layout !== LAYOUTS.mobile) {
      window.addEventListener('resize', computeLayout, false);
    }

    return () => {
      if (layout !== LAYOUTS.mobile) {
        window.removeEventListener('resize', computeLayout, false);
      }
    };
  }, [layout, computedLayout]);

  const {
    iconType,
    actionButtonAppearance,
    actionButtonFormat,
    headingAppearance,
    paragraphAppearance,
  } = getAppearanceConfig(appearance);
  const rootNodeClass = classNames(
    'ws-ui-cta-banner',
    `ws-ui-cta-banner--${appearance}`,
    `ws-ui-cta-banner--layout-${computedLayout}`,
    {
      'ws-ui-cta-banner--rounded-corners': roundedCorners,
      'ws-ui-cta-banner--animated': animate,
    }
  );

  const contentContainerClass = classNames('ws-ui-cta-banner__content-container', {
    'ws-ui-cta-banner__content-container--centered': centered && computedLayout !== LAYOUTS.mobile,
  });

  return (
    <div className={rootNodeClass} ref={rootElementRef}>
      <Box
        // @ts-ignore TS(2322): Type '{ children: Element; paddingLeft: string; pa... Remove this comment to see the full error message
        paddingLeft="spacing-s"
        paddingRight="spacing-s"
        paddingTop={computedLayout === LAYOUTS.mobile ? 'spacing-s' : 'spacing-xs'}
        paddingBottom={computedLayout === LAYOUTS.mobile ? 'spacing-s' : 'spacing-xs'}
      >
        <div className={contentContainerClass}>
          <div
            className={classNames(
              'ws-ui-cta-banner__content',
              `ws-ui-cta-banner__content--layout-${computedLayout}`
            )}
          >
            <div className="ws-ui-cta-banner__text-container">
              {iconGlyph && (
                <div
                  className={classNames(
                    'ws-ui-cta-banner__icon-wrapper',
                    `ws-ui-cta-banner__icon-wrapper--layout-${computedLayout}`
                  )}
                >
                  <Icon glyph={iconGlyph} type={iconType} />
                </div>
              )}
              <div className="ws-ui-cta-banner__text-wrapper">
                <Stack gap="spacing-4-xs">
                  <Heading type="heading-6" appearance={headingAppearance}>
                    {title}
                  </Heading>
                  {subtitle && <Paragraph appearance={paragraphAppearance}>{subtitle}</Paragraph>}
                </Stack>
              </div>
            </div>

            {ctaButton && ctaButton.onClick && (
              <div
                className={classNames(
                  'ws-ui-cta-banner__button-wrapper',
                  `ws-ui-cta-banner__button-wrapper--layout-${computedLayout}`
                )}
              >
                <ActionButton
                  onClick={ctaButton.onClick}
                  appearance={actionButtonAppearance}
                  // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
                  label={ctaButton.label}
                  format={actionButtonFormat}
                  fullWidth={computedLayout === LAYOUTS.mobile}
                />
              </div>
            )}
          </div>

          {onClose && (
            <div className="ws-ui-cta-banner__close">
              {/* @ts-ignore TS(2322): Type '(...args: any[]) => any' is not assignable t... Remove this comment to see the full error message */}
              <IconButton glyph="close" size="small" onClick={onClose} transparent />
            </div>
          )}
        </div>
      </Box>
    </div>
  );
}

export default CtaBanner;
